import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';

@Component({
  selector: 'app-dialog-maxlength',
  templateUrl: './dialog-maxlength.component.html',
  styleUrls: ['./dialog-maxlength.component.css']
})
export class DialogMaxlengthComponent implements OnInit {
  @Input() isZenkaku: boolean = true;
  @Input() inputname: string;
  @Input() max: number;
  @Input() showEmpty: boolean = false;
  @Output() close = new EventEmitter();

  public zenhanlabel = '全角';
  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.zenhanlabel = this.isZenkaku ? '全角' : '半角';
    setTimeout(() => {
      const element = this.el.nativeElement.querySelector('[dialog-maxlength-btn]');
      if (element) {
        element.focus();
      }
    }, 250);
  }

  oncloseDialog() {
    this.close.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/dialog-maxlength/dialog-maxlength.component.ts